export * from './interfaces/daily-score-avg';
export * from './interfaces/weekly-avg';
export * from './interfaces/weekly-report';

export * from './services/report.service';
